<template>
  <v-list-tile
    avatar
    @click="select"
  >
    <v-list-tile-avatar v-if="!noAvatar">
      <v-img :src="$helpers.imageFrom(item.mainImage)"/>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title>{{ item.name }}</v-list-tile-title>
      <v-list-tile-sub-title
        class="text-uppercase"
      >
        {{ $t('SKU:') }} {{ item.sku }}
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <v-chip
        v-if="item.classification !== 'bundle'"
        small
        color="primary"
        class="white--text"
      >
        <span>{{ $t('{0} in stock', [item.inventory.quantity]) }}</span>
      </v-chip>
      <v-chip
        v-else
        small
        color="secondary"
        class="white--text"
      >
        <span>Bundle</span>
      </v-chip>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  name: 'SearchListItem',

  props: {
    item: {
      type: Object,
      required: true
    },
    noAvatar: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    select () {
      this.$emit('selected')
    }
  }
}
</script>
